





































































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AlternativeProduct',
  props: {
    alternativeProduct: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        media: '',
        promotion: '',
        price: 0,
        price_after_cash_discount: 0,
        manufacturers_suggested_retail_price: 0,
        price_after_cashback_discount: 0,
        rating_number: 0,
        total_reviews: 0,
        spli_id: 0,
        can_be_ordered: true
      })
    }
  }
});
